import API from '../../../../../libs/api';

export async function getAiGeneratedAltText(businessId, businessType, params = {}) {
  return API.textCompletion(businessType, businessId, 'ImageAltTextPrompt', params);
}
